import React, { createContext, useState, useEffect } from "react";
import { getCurrentUser } from "../api/api";
import { clearSolutionsOnLogout } from "../utils/solutionStorage";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // ✅ Load from localStorage on refresh
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const [loading, setLoading] = useState(true);

  // ✅ Fetch latest user info (premium status etc.)
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          setLoading(false);
          return;
        }
        const res = await getCurrentUser();
        setUser(res.data.user);

        // Update localStorage with fresh user data
        localStorage.setItem("user", JSON.stringify(res.data.user));
      } catch (err) {
        console.error("Auth check failed:", err);
        logout();
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, []);

  // ✅ Login function
  const login = (data) => {
    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user));
    setUser(data.user);
  };

  // ✅ Logout function
  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    clearSolutionsOnLogout();
  };

  // ✅ Update premium after payment verification
  const upgradeToPremium = () => {
    if (!user) return;
    const updatedUser = { ...user, isPremium: true };
    setUser(updatedUser);
    localStorage.setItem("user", JSON.stringify(updatedUser));
  };

  return (
    <AuthContext.Provider
      value={{ user, login, logout, loading, upgradeToPremium }}
    >
      {children}
    </AuthContext.Provider>
  );
};
